import script from "./study-system.vue?vue&type=script&setup=true&lang=js"
export * from "./study-system.vue?vue&type=script&setup=true&lang=js"

import "./study-system.vue?vue&type=style&index=0&id=5c260b8d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c260b8d"]])

export default __exports__